const pad = (num: number) => `0${num}`.slice(-2);

/**
 * Converts seconds to formatted time with appropriate time unit label
 *
 * @param secs - Number of seconds to convert
 * @returns Object containing formatted time string and time unit
 * @throws Returns { time: "00", timeUnit: "seconds" } for invalid inputs
 */
export function formatTimeWithUnit(secs: number): {
	time: string;
	timeUnit: string;
} {
	// Input validation and error handling
	if (typeof secs !== 'number' || Number.isNaN(secs) || secs < 0) {
		return { time: '00', timeUnit: 'seconds' };
	}

	const secondsRemaining = parseInt(secs.toFixed(0), 10);
	let minutes = Math.floor(secondsRemaining / 60);
	const _secs = secondsRemaining % 60;
	const hours = Math.floor(minutes / 60);
	minutes = minutes % 60;
	let timeUnit = '';
	let time: string;
	if (hours > 0) {
		time = `${pad(hours)} : ${pad(minutes)} : ${pad(_secs)}`;
		timeUnit = 'hours';
	} else if (minutes > 0) {
		time = `${pad(minutes)} : ${pad(_secs)}`;
		timeUnit = 'minutes';
	} else {
		time = `${pad(_secs)}`;
		timeUnit = 'seconds';
	}
	return { time, timeUnit };
}

export function calculateTimeFraction(
	secondsRemaining: number,
	timeLimit: number,
) {
	if (
		Number.isNaN(secondsRemaining) ||
		Number.isNaN(timeLimit) ||
		timeLimit <= 0
	) {
		return 0;
	}

	const rawTimeFraction = secondsRemaining / timeLimit;
	return (
		100 * Math.max(rawTimeFraction - (1 / timeLimit) * (1 - rawTimeFraction), 0)
	);
}
